import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToolsService } from '../../../service/tools/tools.service';

@Injectable({
  providedIn: 'root',
})
export class ToolSnapshotService {
  constructor(private toolsService: ToolsService) {}

  private snapshotsSource = new BehaviorSubject([]);
  currentSnapshots = this.snapshotsSource.asObservable();

  private snapshotsDatesSource = new BehaviorSubject([]);
  currentSnapshotsDates = this.snapshotsDatesSource.asObservable();

  fetchSnapshot(event, row, rowRef, snapshotRef) {
    event.preventDefault();
    event.stopPropagation();
    if (snapshotRef.classList.contains('show')) {
      return this.toggleRow(false, rowRef, snapshotRef);
    }
    if (this.hasSnapshot(row.id)) {
      return this.toggleRow(true, rowRef, snapshotRef);
    }
    this.toolsService.history.tools(row.id).subscribe(
      res => {
        const { data, pagination } = res;
        this.toolsService.readById.tools(row.id, { cache: 'clear', embed: 'model,vehicleDetail' }).subscribe(res => {
          const { data: tool } = res;
          this.addSnapshot({ row, data, pagination, tool });
          this.addSnapshotDates({ id: row.id, data: Object.keys(data) });
          this.toggleRow(true, rowRef, snapshotRef);
        });
      },
      err => {
        console.error(err);
      },
    );
  }

  toggleRow(active, rowRef, snapshotRef) {
    if (active) {
      rowRef.classList.add('active');
      snapshotRef.classList.add('show', 'active');
    } else {
      rowRef.classList.remove('active');
      snapshotRef.classList.remove('show', 'active');
    }
  }

  mergeSnapshotData(obj) {
    // get current list
    const currentList = this.snapshotsSource.value;
    // find the current row
    const currentItem = currentList.find(({ row }) => row.id === obj.row.id);
    // get the new data
    const { data: newData } = obj;
    // get the current data
    const currentData = currentItem.data;

    // iterate over new data keys
    Object.keys(newData).forEach(key => {
      // add new data to merged data
      if (!currentData[key]) currentData[key] = [];
      currentData[key] = [...currentData[key], ...newData[key]];
    });

    currentItem.data = currentData;
    currentItem.pagination = obj.pagination;

    this.replaceSnapshot(currentItem);
  }

  addSnapshotDates(obj) {
    const currentList = this.snapshotsDatesSource.value;
    const updatedList = [...currentList, obj];
    this.snapshotsDatesSource.next(updatedList);
  }

  addSnapshot(obj) {
    const currentList = this.snapshotsSource.value;
    const updatedList = [...currentList, obj];
    this.snapshotsSource.next(updatedList);
  }

  replaceSnapshot(obj) {
    this.removeSnapshot(obj.row.id);
    this.addSnapshot(obj);
  }

  removeSnapshot(id) {
    const currentList = this.snapshotsSource.value;
    const updatedList = currentList.filter(({ row }) => {
      return row.id !== id;
    });
    this.snapshotsSource.next(updatedList);
  }

  hasSnapshot(id) {
    const currentList = this.snapshotsSource.value;
    return currentList.find(({ row }) => {
      return row.id === id;
    });
  }
}
